import { render, staticRenderFns } from "./admin-ope.vue?vue&type=template&id=0c6c7f14&scoped=true&"
import script from "./admin-ope.vue?vue&type=script&lang=js&"
export * from "./admin-ope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6c7f14",
  null
  
)

export default component.exports